import React, { useState, useEffect } from "react";
import { useImpactReadOnly, openImpactBoxIfReadOnly } from "app/routes/psp/management/useImpactReadOnly";
import { useSelector } from "react-redux";
import IntlMessages, { IntlGetText } from "util/IntlMessages";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import CycleVialsForm from "./Form";
import CycleVialsTable from "./Table";
import DeleteCycleVials from "./DeleteCycleVial";
import { NotificationManager } from "react-notifications";
import {
  callApiAsync,
  getCycleVialsInfo,
  postCreateUpdateCycleVials,
  postDeleteCycleVials,
} from "api/apiList";

const CycleVialsDialog = ({
  open,
  handleRequestClose,
  cycleVialsInfo,
  loadCycleVials,
}) => {
  const readOnlyImpactView = useImpactReadOnly();
  const { selectedPrescription } = useSelector(({ management }) => management);
  const [openCRU, setOpenCRU] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [currentRowObj, setCurrentRowObj] = useState(null);
  const msgSuccess = IntlGetText("core.SuccessSave");

  useEffect(() => {
    if (open) loadCycleVials();
  }, [open]);

  const handleCreateUpdate = async (data) => {
    await callApiAsync(
      () => postCreateUpdateCycleVials(data),
      () => {
        setOpenCRU(false);
        NotificationManager.success(msgSuccess);
        loadCycleVials();
      }
    );
  };

  const handleDelete = async () => {
    await callApiAsync(
      () => postDeleteCycleVials(currentRowObj.id),
      () => {
        setOpenDeleteDialog(false);
        NotificationManager.success(msgSuccess);
        loadCycleVials();
      }
    );
  };

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      open={open}
      disableBackdropClick
      onClose={handleRequestClose}
    >
      <DialogTitle>
        <IntlMessages id="core.cycle.vials" />
      </DialogTitle>
      <DialogContent>
        <CycleVialsTable
          data={cycleVialsInfo}
          handleOpenCRU={() => setOpenCRU(true)}
          handleOpenDel={() => setOpenDeleteDialog(true)}
          setCurrentRowObj={setCurrentRowObj}
          readOnly={readOnlyImpactView}
        />
        <CycleVialsForm
          rowObj={currentRowObj}
          prescriptionId={selectedPrescription?.id}
          openCRU={openCRU}
          handleRequestClose={() => setOpenCRU(false)}
          handleCreateUpdate={handleCreateUpdate}
          readOnly={readOnlyImpactView}
        />
        <DeleteCycleVials
          open={openDeleteDialog}
          handleRequestClose={() => setOpenDeleteDialog(false)}
          handleDelete={handleDelete}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleRequestClose} color="secondary">
          <IntlMessages id="core.close" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CycleVialsDialog;
